module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/1-ac957c9bc1c7d96c4eca30ad62c24a7b.jpg";